import { render, staticRenderFns } from "./OpenEndedRemovePickedOption.vue?vue&type=template&id=582d4e45&scoped=true"
import script from "./OpenEndedRemovePickedOption.vue?vue&type=script&lang=js"
export * from "./OpenEndedRemovePickedOption.vue?vue&type=script&lang=js"
import style0 from "./OpenEndedRemovePickedOption.vue?vue&type=style&index=0&id=582d4e45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d4e45",
  null
  
)

export default component.exports